import { service } from 'Services/api/api.service';
import { FeedBackServiceType } from './types';

const BASE_ENDPOINT_URL = 'feedback';

const FeedBackService: FeedBackServiceType = {
  saveFeedback: params => service.post(`${BASE_ENDPOINT_URL}`, params),
};

export default FeedBackService;
